@if (
  {
    row: columnData() | async,
  };
  as $
) {
  <!-- {{$.row | json}} -->
  <p-popover
    #op
    styleClass="overflow-hidden text-sm"
    appendTo="body"
    [dismissable]="true"
  >
    <ng-template #content>
      @if ($.row && $.row?.clt_full_name === undefined) {
        <div>
          <!-- Dropdown Content -->
          <div
            class="surface-0 -mx-4 -mt-4 flex align-items-start justify-content-between px-3 py-2"
          >
            <div class="w-10rem line-height-1">
              <div class="text-sm font-medium text-800">
                {{ $.row.full_name }}
              </div>
              <div class="text-xs text-600 mt-1">{{ $.row.id }}</div>
            </div>
            <div class="mt-1" [innerHTML]="clientStatus($.row)"></div>
          </div>
          <!-- Dropdown Content -->
          <!-- Dropdown Footer -->
          @if ($.row) {
            <div class="px-3 py-2 -mx-4 -mb-4 surface-200 text-800 text-xs">
              <div class="flex align-items-center mb-2">
                <i class="fa fa-phone mr-2 text-500"></i>
                @if ($.row.mobile_number !== 0) {
                  <span
                    >{{ $.row.mobile_country_code
                    }}{{ $.row.mobile_number }}</span
                  >
                }
                @if ($.row.mobile_number === 0) {
                  <span>NA</span>
                }
              </div>
              <div class="flex align-items-center mb-1">
                <i class="fa fa-envelope font-light mr-2 text-500"></i>
                @if ($.row.email_id) {
                  <span> {{ $.row.email_id }}</span>
                }
                @if (!$.row.email_id) {
                  <span>NA</span>
                }
              </div>
            </div>
          }
          <!-- Dropdown Footer -->
        </div>
      } @else {
        <!-- Dropdown Content -->
        <div
          class="surface-0 -mx-4 -mt-4 flex align-items-start justify-content-between px-3 py-2"
        >
          <div class="w-10rem line-height-1">
            <div class="text-sm font-medium text-800">
              {{ $.row?.clt_full_name }}
            </div>
            @if ($.row?.client_id || $.row?.clt_id) {
              <div class="text-xs text-600 mt-1">
                {{
                  $.row?.client_id
                    ? $.row?.client_id
                    : $.row?.clt_id
                      ? $.row?.clt_id
                      : ''
                }}
              </div>
            }
          </div>
          <div class="mt-1" [innerHTML]="clientStatusOther($.row)"></div>
        </div>
        <!-- Dropdown Content -->
        <!-- Dropdown Footer -->
        @if ($.row) {
          <div class="px-3 py-2 -mx-4 -mb-4 surface-200 text-800 text-xs">
            <div class="flex align-items-center mb-2">
              <i class="fa fa-phone mr-2 text-500"></i>
              @if ($.row?.clt_mobile_no !== 0) {
                <span
                  >{{ $.row?.mobile_country_code
                  }}{{ $.row?.clt_mobile_no ? $.row?.clt_mobile_no : '' }}</span
                >
              }
            </div>
            <div class="flex align-items-center mb-1">
              <i class="fa fa-envelope font-light mr-2 text-500"></i>
              @if ($.row?.clt_emailid) {
                <span> {{ $.row.clt_emailid }}</span>
              }
              @if (!$.row?.clt_emailid) {
                <span>NA</span>
              }
            </div>
          </div>
        }
        <!-- Dropdown Footer -->
      }
    </ng-template>
  </p-popover>
  @if ($.row && $.row?.clt_full_name === undefined) {
    <div class="flex align-items-center" (click)="op.toggle($event)">
      <span
        class="cursor-pointer flex align-items-center"
        (mouseenter)="$.row.full_name ? op.show($event) : null"
        (mouseleave)="op.hide()"
        (click)="executeAction('showProfile', $.row); op.toggle($event)"
      >
        @if (!$.row.image && $.row.full_name) {
          <p-avatar
            [label]="$.row.full_name | titlecase | shortName"
            shape="circle"
            styleClass="text-sm"
          />
        } @else {
          <p-avatar [image]="$.row.image" shape="circle" />
          @if (!$.row.full_name) {
            <span>-</span>
          }
        }
        <strong class="ml-2 text-primary">{{ $.row.full_name }}</strong>
      </span>
    </div>
  } @else {
    <div class="flex align-items-center" (click)="op.toggle($event)">
      <span
        class="cursor-pointer flex align-items-center"
        (mouseenter)="$.row?.clt_full_name ? op.show($event) : null"
        (mouseleave)="op.hide()"
        (click)="executeAction('showProfile', $.row); op.toggle($event)"
      >
        @if (
          isEmptyAndNull($.row.clt_image) &&
          !isEmptyAndNull($.row.clt_full_name)
        ) {
          <p-avatar
            [label]="$.row?.clt_full_name | titlecase | shortName"
            shape="circle"
            styleClass="text-sm"
          />
        } @else {
          <p-avatar [image]="$.row.clt_image" shape="circle" />
          @if (!$.row?.clt_full_name) {
            <span>-</span>
          }
        }
        <strong class="ml-2 text-primary">{{ $.row?.clt_full_name }}</strong>
      </span>
    </div>
  }
}
